module.exports = __webpack_public_path__ + "img/module-bg.6f73af23.jpg";